/* eslint-disable */
import axios from 'axios'

const getCookie = key => {
  const cookie = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)')
  return cookie ? cookie[2] : null
}

const redirectInvalidUser = () => {
  window.location.replace(process.env.VUE_APP_URL + '#openAccount')
  return false
}

const fileDownload = (link, fileName) => {
  axios({
    url: link,
    method: 'GET',
    responseType: 'blob'
  }).then(response => {
    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink = document.createElement('a')

    fileLink.href = fileURL
    fileLink.setAttribute('download', fileName.toLowerCase())
    document.body.appendChild(fileLink)

    fileLink.click()
  })
}

const getFileS3 = async link => {
  let url = process.env.VUE_APP_CUSTOMER_PANEL_API_URL
  url += process.env.VUE_APP_AWS_FILE
  let responseS3 = null
  await axios
    .get(url + btoa(link))
    .then(response => {
      if (response.data.url) {
        responseS3 = response.data.url
      }
    })
    .catch(function (error) {
      return error
    })

  return responseS3
}

const getMobSessid = () => {
  const live = process.env.VUE_APP_MOBSESSID
  const cookie = document.cookie.match('(^|;) ?' + live + '=([^;]*)(;|$)')
  return cookie ? cookie[2] : null
}

const getCustomerDocument = async () => {
  const url = process.env.VUE_APP_CUSTOMER_PANEL_API_URL

  const mobsessid = getMobSessid()

  if (mobsessid == null) {
    redirectInvalidUser()
    return
  }

  try {
    const { data: { document } } = await axios.get(`${url}/customer/${mobsessid}/document`)

    return document
  } catch (error) {
    console.error('error: ', error)
  }
}

const consoleLog = () => { if (typeof false === 'undefined' || !false || !window.console || !console) return !1; if (arguments.length > 1) { const a = []; for (const argument in arguments)a.push(arguments[argument]); console.log(a.shift(), a.shift(), a) } else console.log(arguments) }

const lazyLoadFile = (a, b) => { consoleLog('@ lazyLoadFile @', 'Loading ' + a); const c = function () { this.onreadystatechange = null, this.onload = null, window.setTimeout(b, 20), consoleLog('@ lazyLoadFile @', 'Loaded ' + a) }; const d = document.createElement('script'); d.type = 'text/javascript', d.async = 1, d.defer = 1, b && (d.onreadystatechange = function () { const a = this.readyState; (a == 'loaded' || a == 'complete') && c() }, d.onload = c), d.src = a, document.body.appendChild(d) }

const formatDocument = (document) => {
  if (document && document.length === 11) {
    const cpfMask = /(\d{3})(\d{3})(\d{3})(\d{2})/
    return document.replace(cpfMask, '$1.$2.$3-$4')
  }

  if (document && document.length === 14) {
    const cnpjMask = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/
    return document.replace(cnpjMask, '$1.$2.$3/$4-$5')
  }

  return document
}

const currencyFormat = (value) => {
  if (typeof value === 'string') {
    return `R$ ${value}`
  }

  return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

const dateFormat = (date) => {
  const dateObj = new Date(date)
  dateObj.setHours(dateObj.getHours() + 3)
  const day = String(dateObj.getDate()).padStart(2, '0')
  const month = String(dateObj.getMonth() + 1).padStart(2, '0')
  const year = String(dateObj.getFullYear())
  return `${day}/${month}/${year}`
}

export {
  getCookie,
  redirectInvalidUser,
  fileDownload,
  getFileS3,
  getMobSessid,
  consoleLog,
  lazyLoadFile,
  getCustomerDocument,
  formatDocument,
  currencyFormat,
  dateFormat
}
